'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { useAppSelector } from 'EmailDragDropEditorUI/reducers';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import EmailDetailsSettings from 'EmailDragDropEditorUI/components/settings/EmailDetailsSettings';
import EmailDetailsContent from 'EmailDragDropEditorUI/components/settings/EmailDetailsContent';
import PlainTextAndWebVersionSettings from 'EmailDragDropEditorUI/components/settings/PlainTextAndWebVersion/PlainTextAndWebVersionSettings';
import { NavMarker } from 'react-rhumb';
import { withErrorBoundary } from 'EmailEditorUI/hoc/withErrorBoundary';
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EmailSettingsContainer() {
  const isVariant = useAppSelector(getIsABVariant);
  const isReadOnlyMode = useAppSelector(getIsReadOnlyMode);
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "center",
    paddingInline: "600",
    paddingBlockStart: "1000",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SETTINGS_TAB_RENDERED"
    }), /*#__PURE__*/_jsx(Fieldset, {
      disabled: isReadOnlyMode,
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "100%",
        maxInlineSize: "700px",
        paddingBlockEnd: "1300",
        "data-test-id": "settings-form",
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "emailSettings.metaSettings.header"
          })
        }), /*#__PURE__*/_jsx(EmailDetailsContent, {}), /*#__PURE__*/_jsx(EmailDetailsSettings, {
          isVariant: isVariant
        }), /*#__PURE__*/_jsx(PlainTextAndWebVersionSettings, {})]
      })
    })]
  });
}
export default withErrorBoundary(EmailSettingsContainer);